import React, { useRef, useEffect } from 'react';

const SCROLL_OPTIONS: ScrollIntoViewOptions = {
  block: 'start',
  inline: 'start',
  behavior: 'smooth',
};

type AutoScrollProps = {
  // The content to be revealed by scrolling the browser when the content is first rendered.
  children: React.ReactNode;
  // Optionally, scrolling (to the top of the content) will also occur whenever this key changes.
  scrollKey: any;
};

// When this component's children are first rendered, the browser is scrolled
// so that the top of the children is visible in the browser window.
//
// Scrolling will also occur when the value of `scrollKey` changes,
// triggering the useEffect callback.
const AutoScroll = ({ children, scrollKey }: AutoScrollProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const element = ref.current;

  useEffect(() => {
    if (element) {
      element.scrollIntoView(SCROLL_OPTIONS);
    }
  }, [scrollKey, element]);

  return <div ref={ref}>{children}</div>;
};

const withAutoScroll = Component => props => {
  return (
    <AutoScroll scrollKey={null}>
      <Component {...props} />
    </AutoScroll>
  );
};

export { AutoScroll, withAutoScroll };
